import React from "react"
import styled from "styled-components"

import { NavLink } from "../Nav"
import { RosterNav } from "./RosterNav"

const StyledNavLink = styled(NavLink)`
  color: ${props => props.theme.lightGrey2};
`

export function RosterLinksMenu({ show = false, publicCategories }) {
  return (
    <RosterNav expanded={show}>
      {publicCategories.map(category => (
        <li key={category.name}>
          <StyledNavLink
            to={`/roster?category=${encodeURIComponent(category.name)}`}
          >
            {category.name}
          </StyledNavLink>
        </li>
      ))}
      <li>
        <StyledNavLink to="/roster?category=all">All</StyledNavLink>
      </li>
    </RosterNav>
  )
}
